export const BASE_URL = process.env.REACT_APP_BACKEND_URL;
export const INVOICE_BASE_URL = process.env.REACT_APP_INVOICE_BACKEND_URL;
